import { generateId } from '@revenuemarket/utils';

import overlayEventContext from './event';
import { OverlayOpenCallback } from '../types';

export const overlays = {
  open: (callback: OverlayOpenCallback) => {
    const id = generateId();
    overlayEventContext.notifyOpen(id, callback);
    return id;
  },
  close: (id: string) => {
    overlayEventContext.notifyClose(id);
  },
};
